document.addEventListener('DOMContentLoaded', () => {
  // -----------------------------
  // PRODUCT PAGE QUANTITY LOCK
  // -----------------------------
  const productQuantityInput = document.querySelector(
    'quantity-input input[name="quantity"]'
  );

  if (productQuantityInput) {
    const productQuantityWrapper =
      productQuantityInput.closest('quantity-input');

    function isScentClubSelected() {
      const sellingPlanInput = document.querySelector(
        'input[name="selling_plan"]:checked, select[name="selling_plan"]'
      );

      return sellingPlanInput && sellingPlanInput.value;
    }

    function updateProductQuantityLock() {
      const scentClubSelected = isScentClubSelected();

      if (scentClubSelected) {
        productQuantityInput.value = 1;
        productQuantityInput.setAttribute('readonly', 'readonly');

        if (productQuantityWrapper) {
          productQuantityWrapper
            .querySelectorAll('button')
            .forEach((button) => {
              button.disabled = true;
            });
        }

        productQuantityInput.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      } else {
        productQuantityInput.removeAttribute('readonly');

        if (productQuantityWrapper) {
          productQuantityWrapper
            .querySelectorAll('button')
            .forEach((button) => {
              button.disabled = false;
            });
        }
      }
    }

    document.addEventListener('change', (event) => {
      if (
        event.target.matches(
          'input[name="selling_plan"], select[name="selling_plan"]'
        )
      ) {
        updateProductQuantityLock();
      }
    });

    updateProductQuantityLock();
  }

  // -----------------------------
  // CART PAGE QUANTITY LOCK
  // -----------------------------
  function lockScentClubCartItems() {
    document
      .querySelectorAll(
        'quantity-input[data-scent-club="true"]'
      )
      .forEach((quantityWrapper) => {
        const quantityInput =
          quantityWrapper.querySelector('input[name="updates[]"]');

        if (!quantityInput) return;

        quantityInput.value = 1;
        quantityInput.setAttribute('readonly', 'readonly');
        quantityInput.setAttribute('min', '1');
        quantityInput.setAttribute('max', '1');

        quantityWrapper
          .querySelectorAll('button')
          .forEach((button) => {
            button.disabled = true;
          });
      });
  }

  lockScentClubCartItems();

  const observer = new MutationObserver(() => {
    lockScentClubCartItems();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});